export const REGELKONTROLLE_GROUPS = [
  {
    id: "krone",
    label: "in der Krone",
    items: [
      { id: "krone_astab", label: "K1 Astab- bzw. Astausbrüche" },
      { id: "krone_astrisse", label: "K2 Astrisse" },
      { id: "krone_astungswunden", label: "K3 Astungswunden oder -fäulen" },
      { id: "krone_bewuchs", label: "K4 Baumfremder Bewuchs" },
      { id: "krone_belaubung", label: "K5 Belaubung (Auffälligkeiten)" },
      { id: "krone_fehlentwicklung", label: "K6 Fehlentwicklungen in d. Krone" },
      { id: "krone_hohlungen", label: "K7 Höhlungen" },
      { id: "krone_kappungen", label: "K8 Kappungsstellen" },
      { id: "krone_sicherungen", label: "K9 Kronensicherungen" },
      { id: "krone_lichtraum", label: "K10 Lichtraumprofil" },
      { id: "krone_pilz", label: "K11 Pilzbefall, ggf. Pilzart" },
      { id: "krone_rinde", label: "K12 Rindenschäden" },
      { id: "krone_totholz", label: "K13 Totholzbildung" },
      { id: "krone_zwiesel", label: "K14 Vergabelungen, Zwiesel" },
      { id: "krone_wipfelduerre", label: "K15 Wipfeldürre" },
    ],
  },
  {
    id: "stamm",
    label: "am Stamm",
    items: [
      { id: "stamm_anfahrt", label: "S1 Anfahrschäden" },
      { id: "stamm_astung", label: "S2 Astungswunden" },
      { id: "stamm_bewuchs", label: "S3 Baumfremder Bewuchs" },
      { id: "stamm_faulen", label: "S4 Fäulen" },
      { id: "stamm_gewindestangen", label: "S5 Gewindestangen, Plomben o.ä." },
      { id: "stamm_hohlungen", label: "S6 Höhlungen" },
      { id: "stamm_pilz", label: "S7 Pilzbefall, ggf. Pilzart" },
      { id: "stamm_rinde", label: "S8 Rindenschäden" },
      { id: "stamm_risse", label: "S9 Risse" },
      { id: "stamm_insekten", label: "S10 Schadinsekten (z.B. Bohrmehl)" },
      { id: "stamm_neigung", label: "S11 Schrägstand" },
      { id: "stamm_austriebe", label: "S12 Stammaustriebe" },
      { id: "stamm_verletzungen", label: "S13 Verletzungen" },
      { id: "stamm_anomalien", label: "S14 Wuchsanomalien" },
      { id: "stamm_zwiesel", label: "S15 Zwiesel" },
    ],
  },
  {
    id: "stammfuss",
    label: "am Stammfuß/Wurzelanlauf",
    items: [
      { id: "stammfuss_wurzel", label: "W1 Adventiv-, Würgewurzeln" },
      { id: "stammfuss_hohlungen", label: "W2 Höhlungen" },
      { id: "stammfuss_pilz", label: "W3 Pilzbefall, ggf. Pilzart" },
      { id: "stammfuss_rinde", label: "W4 Rindenschäden" },
      { id: "stammfuss_risse", label: "W5 Risse" },
      { id: "stammfuss_verbreiterung", label: "W6 Stammfußverbreiterung" },
      { id: "stammfuss_stockaustriebe", label: "W7 Stockaustriebe" },
      { id: "stammfuss_anomalien", label: "W8 Wuchsanomalien" },
    ],
  },
  {
    id: "wurzel",
    label: "im Wurzelbereich",
    items: [
      { id: "wurzel_anhebungen", label: "Wu1 Bodenaufwölbungen" },
      { id: "wurzel_risse", label: "Wu2 Bodenrisse" },
      { id: "wurzel_pilz", label: "Wu3 Pilzbefall, ggf. Pilzart" },
    ],
  },
  {
    id: "baumumfeld",
    label: "Veränderungen im Baumumfeld",
    items: [
      { id: "umfeld_baugruben", label: "V1 Baugruben, -gräben" },
      { id: "umfeld_abtrag", label: "V2 Bodenauf- oder -abtrag" },
      { id: "umfeld_verdichtung", label: "V3 Bodenverdichtung" },
      { id: "umfeld_versiegelung", label: "V4 Bodenversiegelung" },
      { id: "umfeld_freistellung", label: "V5 Freistellung" },
      { id: "umfeld_grundwasser", label: "V6 Grundwasserabsenkung, Grundwasseranstau" },
    ],
  },
];
